import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

const Cookies = () => {
  const [showBanner, setShowBanner] = useState(true);

  const acceptCookies = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShowBanner(false);
  };

  return (
    showBanner && (
      <aside className="cookie-banner">
        <p>
          Nous utilisons des cookies pour améliorer votre expérience sur notre site.
          En continuant, vous acceptez notre utilisation des cookies.
          <NavLink>En savoir plus</NavLink>
        </p>
        <button onClick={acceptCookies}>Accepter</button>
      </aside>
    )
  );
};

export default Cookies;
